// extracted by mini-css-extract-plugin
export default {"root":"k6xmPe","searchBar":"x9788m","searchIcon":"lhJoWU","rightIcon":"vn3DhL","tags":"xJBFQ8","categories":"NSydQE","input":"ChSq1Q"};